export default __webpack_public_path__ + "static/Ayman_CV-50ad44e2680c6dce99dcb674f54fdd5a.pdf";